import React from 'react'
import { useTranslation } from 'react-i18next';
interface Feature {
    title:  string
    image: string
}

function Features({items}) {
    const { t } = useTranslation();
    function feature(item : Feature, key : number) {
        return(
            <div key={key} className="col-lg-3">
                {/* <!-- icon box --> */}
                <div className="knsl-icon-box knsl-scroll-animation">
                <img src={item.image} alt={t(`main.${item.title}`)} className="knsl-mb-10" />
                <h5>{t(`main.${item.title}`)}</h5>
                </div>
                {/* <!-- icon box end --> */}
            </div>
        )
    }

    return(
        <section className="knsl-p-0-90">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">

                        <div className="knsl-center knsl-title-frame knsl-mb-100">
                        <h2 className="knsl-mb-20">{t('main.whatDoWeOffer')}</h2>
                        <p className="knsl-mb-30">{t('main.whatDoWeOfferDesc')}</p>
                        <button className="knsl-btn knsl-btn-md">{t('main.services')}</button>
                        </div>

                    </div>
                    {items.map((item:Feature, index) => feature(item, index))}
                </div>
            </div>
        </section>
    )
}

export default Features